module.exports = __webpack_public_path__ + "static/image4-23d49175a8b6bec74b6ff613c60ec6d9.jpg";